import { ca } from '@cian/analytics';

/**
 * @description Событие: пользователь изменил фильтр срока ипотеки в блоке ипотечных офферов.
 */
export const trackTermFilterChange = (): void => {
  ca('eventSite', {
    action: 'click_sopr',
    category: 'Promo',
    label: 'mortgage_term',
    name: 'oldevent',
    useLastProducts: true,
  });
};
